import styles from './StatusBadge.module.css';

export type CourseStatusBadgeTone = 'archived' | 'completed' | 'live';

interface StatusBadgeProps {
  label: string;
  tone: CourseStatusBadgeTone;
}

export function StatusBadge({ label, tone }: StatusBadgeProps) {
  return (
    <span className={styles.badge} data-tone={tone}>
      {label}
    </span>
  );
}
